.container {
  flex: 1;
}

.title {
  display: flex;
}
